import {every, filter, isEmpty, some} from 'lodash-es'
import type {PaymentFrequency} from '../../../constants/paymentFrequencies'
import {PAYMENT_FREQUENCY_YEARLY} from '../../../constants/paymentFrequencies'
import type {Package} from './types'

export const shouldDisplayCard = (packageOffer: Package, frequency: PaymentFrequency = PAYMENT_FREQUENCY_YEARLY) => {
  if (isEmpty(packageOffer)) return false
  const priceByFrequency = packageOffer[frequency]
  return !priceByFrequency?.pending && !priceByFrequency?.error
}

export const isFrequencyReady = (packageOffers: Package[], frequency: PaymentFrequency) => {
  if (isEmpty(packageOffers)) return false
  return every(
    packageOffers,
    (packageOffer) => packageOffer[PAYMENT_FREQUENCY_YEARLY]?.error || !packageOffer[frequency].pending,
  )
}

export const shouldHideLoader = (packageOffers: Package[]) => {
  return isFrequencyReady(packageOffers, PAYMENT_FREQUENCY_YEARLY)
}

export const shouldNavigate = (packageOffers: Package[]) => {
  if (isEmpty(packageOffers)) return false

  return some(packageOffers, (packageOffer) => shouldDisplayCard(packageOffer))
}

export const hasEnoughPackageOffers = (packageOffers: Package[]) => {
  if (isEmpty(packageOffers)) return false

  return filter(packageOffers, (packageOffer) => shouldDisplayCard(packageOffer)).length >= 3
}
